"use client";

import { getCurrentPath } from "@faire/web--source/common/Path";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";

import { useHeaderSignUpCopy } from "../../__internal__/useHeaderSignUpCopy";
import { useNavigateAndHideMenu } from "../../mobile/Navigation/useNavigateAndHideMenu";
import { HeaderLinkButton } from "../../styled";
import { HeaderButton } from "../../styled";

export const LoggedOutLoginSection: React.FC = () => {
  return (
    <>
      <LoginLink />
      <SignUpLink />
    </>
  );
};

export const LoginLink: React.FC = () => {
  const { navigateToSignIn } = useNavigateAndHideMenu();
  return (
    <HeaderLinkButton onClick={() => navigateToSignIn()} data-test-id="login">
      <StrictLocalMsg
        defaultMessage="Sign in"
        description={{
          text: "title of link that leads to the sign in page",
        }}
      />
    </HeaderLinkButton>
  );
};

const SignUpLink: React.FC = () => {
  const isSSR = useIsSSR();
  const { navigateToSignUp } = useNavigateAndHideMenu();
  const signUpCopy = useHeaderSignUpCopy();

  return (
    <HeaderButton
      onClick={() =>
        navigateToSignUp(undefined, {
          sourceId: "desktop_catnav_signup_cta",
        })
      }
      // We set a link for graceful degradation in SSR.
      linkTo={
        isSSR
          ? getCurrentPath()
              .replace({
                signUp: "1",
              })
              .toString()
          : undefined
      }
      data-test-id="signUpButton"
    >
      {signUpCopy}
    </HeaderButton>
  );
};
